import { useTranslation } from "react-i18next";
import { useSupportedDevice } from "../../../../context/SupportedDeviceContext";
import styles from "./style.module.scss";

const TopArea = () => {
  const { t } = useTranslation();
  const { setShowModal } = useSupportedDevice();
  const scrollToElementById = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className={styles.topAreaContainer}>
      <img
        alt="easysims_logo"
        src={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/hiddenStore/topArea_bg.png`}
        className={styles.topArea}
      />
      <div className={styles.btnGroup}>
        <div
          className={styles.deviceBtn}
          onClick={() => {
            scrollToElementById("deviceArea");
          }}
        >
          <div className={`${styles.deviceTxt} txt`}>
            {t("normal.check.avaliable.device")}
          </div>
        </div>
        <div
          className={styles.stepsBtn}
          onClick={() => {
            scrollToElementById("homeStepArea");
          }}
        >
          <div className={`${styles.stepsTxt} txt`}>
            {t("header.esim.guide")}
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default TopArea;
